import React from "react"
import { css } from "@emotion/core"
import t from "theme"

const Divider = ({ color = t.color.border, size = "100%", width = "1px", direction = "H", space = 0, ...props }) => {
    if (direction === "V") {
        return (
            <div
                css={css`
                    background-color: ${color};
                    width: ${width};
                    height: ${size};
                    margin: 0 ${space};
                `}
                {...props}>
                &nbsp;
            </div>
        )
    } else {
        return (
            <div
                css={css`
                    background-color: ${color};
                    height: ${width};
                    width: ${size};
                    margin: ${space} 0;
                `}
                {...props}>
                &nbsp;
            </div>
        )
    }
}

export default Divider
